import $ from "jquery";
export const removeClasses = {
    init: () => {
        removeClasses.enableGlobal();
        $("[data-remove-classes-for]").on("click", function () {
            const $thisElement = $(this);
            const target = $thisElement.data("remove-classes-for");
            const classesToRemove = $thisElement
                .data("remove-classes")
                .split(",")
                .join(" ");
            $(target).removeClass(classesToRemove);
        });
    },
    enableGlobal: () => {
        if (!window["removeClasses"]) {
            window["removeClasses"] = removeClasses;
        }
    },
};
